module.exports = __webpack_public_path__ + "static/img/xz.7312745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/xz.png
// module id = ghit
// module chunks = 1